import { css } from '@emotion/react';

export const backgroundCss = (hasError) => (theme) =>
  css`
    ${hasError
      ? `background-color: ${theme.color.white};`
      : `background: ${theme.color.primary} ${
          theme.asset.background ? `url(${theme.asset.background})` : ''
        } repeat-x top left;`}
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  `;
